import { Checkbox } from '@/ui';
import PropTypes from 'prop-types';

// Checkbox + link row shared by account activation and invitation accept.
export default function TermsAcceptField({
  checked,
  onChange,
  disabled,
  onOpenTerms,
}) {
  return (
    <div className="login-terms">
      <label className="login-terms__accept">
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label="Acepto los términos y condiciones"
          aria-required
        />
        <span>Acepto los</span>
      </label>
      {/* The link sits outside the label: a label admits one labelable
          descendant, and Checkbox already renders a button. Keeping the
          checkbox and its text inside preserves click-the-text toggling. */}
      <button type="button" className="login-terms-link" onClick={onOpenTerms}>
        términos y condiciones
      </button>
    </div>
  );
}

TermsAcceptField.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onOpenTerms: PropTypes.func.isRequired,
};
